module.exports = __webpack_public_path__ + "static/img/t1-4.d136ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/en/t1-4.png
// module id = YUk3
// module chunks = 1